import { BehaviorSubject } from "rxjs";
import { container, singleton } from "tsyringe";
import { Config } from "../config";
import { fetchAndThrowHttpErrors } from "../utils/helpers";
import { ErrorService } from "./error-service";
import { PTApiService } from "./ptapi-service";
import { UserService } from "./user-service";

// Extends the BJNCore apiClient to add more HTTP call possibilities to SEAM API
@singleton()
export class SEAMApiService {

    // using DI in constructor would require to eject the app
    private userService = container.resolve(UserService);
    private errorService = container.resolve(ErrorService);

    private tokenExchangeEndpointUrl = `${Config.BJ_TOKEN_EXCHANGE_URL}`;


    private userFeatures$ = new BehaviorSubject<{ name: string, available: boolean, editable: boolean }[]>(null);
    private jwtMeetingToken$ = new BehaviorSubject<string>(null);


    get apiBaseUrl() {
        return (window as any).BJNCore?.mainStore?.meetingJoinStore?.bjnApiClient?.apiUrls?.baseApiUrl;
    }

    get meetingToken() {
        // console.log('get meeting Token');
        return (window as any).BJNCore?.mainStore?.meetingJoinStore?.currentMeeting?.roomPairingStore?.meetingSession?.meetingToken;
    }

    async jwtMeetingToken() {
        let jwtToken = this.jwtMeetingToken$.getValue();
        if (!jwtToken) {
            return await this.exchangeJWTToken();
        } else {
            return jwtToken;
        }
    }

    get endpointGUID() {
        return (window as any).BJNCore?.mainStore?.meetingJoinStore?.currentMeeting?.roomPairingStore?.meetingSession?.endpointGuid;
    }

    leaveMeeting() {
        (window as any).BJNCore?.mainStore?.meetingJoinStore?.leaveMeeting();
    }

    async fetchUserFeatures() {
        const features = await fetchAndThrowHttpErrors(`${this.apiBaseUrl}v1/user/${this.userService.user.id}/features`, {
            headers: {
                Authorization: `Bearer ${this.userService.bjToken$.value}`
            }
        }) as { name: string, available: boolean, editable: boolean }[];

        this.userFeatures$.next(features);

        return features;
    }

    async ensureRequiredFeaturesEnabled() {
        const features = await this.fetchUserFeatures();

        if (!Config.DISABLE_PT_SEQUIN_FEATURE_CHECK && !features.find(f => f.name === 'pt_sequin' && f.available)) {
            this.errorService.throwError({ type: 'fatal', code: 'NO_PT_SEQUIN_FEATURE', message: 'Feature "pt_sequin" is required to use Studio. Please ask your administrator to add it to your account and try creating a new event.' });
            return false;
        }

        return true;
    }

    async exchangeJWTToken() {
        console.log('exchangeJWTToken');
        const jwt = await fetchAndThrowHttpErrors(`${this.tokenExchangeEndpointUrl}token-exchange/accesstoken`, {
            method: 'POST',
            headers: {},
            body: JSON.stringify({
                grantType: 'MEETING',
                token: this.meetingToken
            })
        });

        if (jwt && jwt.token) {
            this.jwtMeetingToken$.next(jwt.token);
            console.log('seam token', jwt.token);
            return jwt.token
        }
        return null;
    }

}
